import React from 'react';
import styles from './ProductSearch.module.css';

interface ProductSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export const ProductSearch: React.FC<ProductSearchProps> = ({ value, onChange }) => {
  return (
    <div className={styles.searchBox}>
      <svg className={styles.searchIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.35-4.35" />
      </svg>
      <input
        className={styles.searchInput}
        type="text"
        placeholder="Search by SKU, product name, or category..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};
